import { formatLocalDate } from '@shared/lib/date';
import { Card } from '@shared/ui/card';

import type { Fund } from '../model/fund';
import { FUND_INFO_CARD_TEXT } from './fund-info-card.text';

export interface FundInfoCardProps {
  fund: Pick<Fund, 'name' | 'fundDuration' | 'commentInvestmentTarget'>;
}

/** 펀드 상세 맨 위의 펀드 정보 카드: 이름 · 존속기간 · 펀드 목적 */
export function FundInfoCard({ fund }: FundInfoCardProps) {
  const [start, end] = fund.fundDuration;
  const duration =
    start && end
      ? `${FUND_INFO_CARD_TEXT.duration} ${formatLocalDate(start)} - ${formatLocalDate(end)}`
      : '';

  return (
    <Card gap="sm" className="h-full w-full">
      <h2 className="text-fg-default typo-heading-4">{fund.name}</h2>
      <p className="text-fg-muted typo-body-sm">{duration}</p>
      <dl className="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto rounded-md bg-bg-primary-subtle p-2-5">
        <dt className="text-fg-muted typo-caption">{FUND_INFO_CARD_TEXT.purpose}</dt>
        <dd className="whitespace-pre-line text-fg-default typo-label-sm">
          {fund.commentInvestmentTarget}
        </dd>
      </dl>
    </Card>
  );
}
